// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageChatSquareIcon from "@/assets/icons/message-chat-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageChatSquareIconProps = Omit<IconProps, "name">;

export function MessageChatSquareIcon(props: MessageChatSquareIconProps): React.ReactNode {
  return <Icon name={messageChatSquareIcon} {...props} />;
}
